import { Button, Select } from 'antd';
import type { PatientSortOption } from '@/models/patient';
import styles from './PatientSubHeader.module.css';

interface PatientSubHeaderProps {
  totalCount: number;
  sortOption: PatientSortOption;
  onSortChange: (option: PatientSortOption) => void;
  hasActiveFilters: boolean;
  activeFilterCount: number;
  onClearFilters: () => void;
  onNewPatient?: () => void;
}

const SORT_OPTIONS: { label: string; value: PatientSortOption }[] = [
  { label: 'Latest Study', value: 'latest_study_date' },
  { label: 'Oldest Study', value: '-latest_study_date' },
  { label: 'Name A → Z', value: 'last_name' },
  { label: 'Name Z → A', value: '-last_name' },
];

export default function PatientSubHeader({
  totalCount,
  sortOption,
  onSortChange,
  hasActiveFilters,
  activeFilterCount,
  onClearFilters,
  onNewPatient,
}: PatientSubHeaderProps) {
  return (
    <div className={styles.subHeaderRow}>
      <span className={styles.counter}>
        {totalCount} {totalCount === 1 ? 'patient' : 'patients'}
      </span>

      <div className={styles.rightGroup}>
        {hasActiveFilters && (
          <div className={styles.filterIndicator}>
            <div className={styles.divider} />
            <span className={styles.filterDot} />
            <span className={styles.filterText}>
              {activeFilterCount}{' '}
              {activeFilterCount === 1 ? 'filter' : 'filters'} active
            </span>
            <button
              type="button"
              className={styles.resetButton}
              onClick={onClearFilters}
            >
              Reset
            </button>
          </div>
        )}

        <Select
          value={sortOption}
          onChange={onSortChange}
          options={SORT_OPTIONS}
          className={styles.sortSelect}
          size="small"
        />

        {onNewPatient && (
          <Button type="primary" size="small" onClick={onNewPatient}>
            New Patient
          </Button>
        )}
      </div>
    </div>
  );
}
